// extracted by mini-css-extract-plugin
export default {"device-login-connect":"I+D0s","deviceLoginConnect":"I+D0s","connect-button":"sBS0G","connectButton":"sBS0G"};